import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import styles from './envBanner.module.scss'

const variantTypes = ['tst', 'acc', 'none']

function EnvBanner(props) {
    const { variant } = props

    if (!variant || variant === 'none') {
        return null
    }

    return variantTypes.includes(variant) ? (
        <>
            <div
                className={cx(styles.banner, {
                    [styles.lightPurple]: variant === 'tst',
                    [styles.lightOrange]: variant === 'acc',
                })}
            />
        </>
    ) : null
}

EnvBanner.propTypes = {
    variant: PropTypes.oneOf(variantTypes),
}

export default EnvBanner
